import React, { useContext, useEffect, useState } from "react";
import {
  TextField,
  Button,
  CircularProgress,
  Typography,
  Box,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useSpring, animated } from "@react-spring/web";
import { UserContext } from "./AdminPanel/context/UserContext";
import logoImage from "./img/soikud.png";
import "./styles/Login.css";

const Login = () => {
  const [credentials, setCredentials] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const { loginUser, currentUser } = useContext(UserContext);

  useEffect(() => {
    const checkAuth = async () => {
      const token = localStorage.getItem('token');
      if (token && currentUser) {
        navigate("/admin", { replace: true });
      }
    };

    checkAuth();
  }, [currentUser, navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCredentials(prev => ({ ...prev, [name]: value.trim() }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    const { email, password } = credentials;

    // E-posta formatı kontrolü
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email || !password) {
      setError("Email ve şifre gereklidir.");
      return;
    } else if (!emailPattern.test(email)) {
      setError("Geçerli bir e-posta adresi girin.");
      return;
    }

    try {
      setLoading(true);
      await loginUser(email, password);
      setCredentials({ email: "", password: "" });
      navigate("/admin", { replace: true });
    } catch (err) {
      setError(
        err.message ||
        err.response?.data?.error ||
        err.response?.data?.details ||
        err.response?.data?.message ||
        "Giriş başarısız. Lütfen bilgilerinizi kontrol edin."
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const handleBeforeUnload = () => {
      setCredentials({ email: "", password: "" });
      setError("");
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, []);

  const iconAnimation = useSpring({
    from: { transform: "scale(1)" },
    to: { transform: "scale(1.1)" },
    config: { tension: 300, friction: 10 },
    loop: { reverse: true },
  });

  return (
    <Box
      className="login-body"
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100vh"
    >
      <Box className="login-container">
        <Box className="login-box">
          <animated.img
            src={logoImage}
            alt="Logo"
            className="login-logo"
            style={iconAnimation}
          />
          <form onSubmit={handleSubmit} noValidate>
            <TextField
              label="E-Posta"
              name="email"
              type="email"
              variant="outlined"
              fullWidth
              value={credentials.email}
              onChange={handleChange}
              required
              autoComplete="email"
            />
            <TextField
              label="Şifre"
              name="password"
              variant="outlined"
              type="password"
              fullWidth
              value={credentials.password}
              onChange={handleChange}
              required
              autoComplete="current-password"
            />
            {error && (
              <Typography color="error" sx={{ mb: 2 }}>
                {error}
              </Typography>
            )}
            <Button
              type="submit"
              className="login-button"
              fullWidth
              disabled={loading}
            >
              {loading ? <CircularProgress size={20} /> : "Giriş Yap"}
            </Button>
            <Button
              type="button"
              className="login-signup-button"
              fullWidth
              onClick={() => navigate("/signup")}
            >
              Üyelik İste
            </Button>
            <Button
              type="button"
              className="login-forgot-password-button"
              fullWidth
              onClick={() => navigate("/forgot-password")}
            >
              Şifremi Unuttum
            </Button>
          </form>
        </Box>
      </Box>
    </Box>
  );
};

export default Login;
